import styled from 'styled-components'
import Box from 'UIKit/Box/Box'
import Text from 'UIKit/Text'

export const StyledWrapTab = styled(Box).attrs({ disabledDefaultStyle: true })<{ $active?: boolean }>`
  height: ${({ theme }) => theme.bottombarHeight};
  display: flex;
  flex-direction: column;
  justify-items: center;
  position: relative;
  width: 100%;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 852px) {
    &:hover {
      * {
        color: ${({ theme }) => theme.colors.text};
      }
    }
  }
`

export const StyledWrapIcon = styled(Box)<{ $active?: boolean }>`
  width: 24px;
  height: 24px;

  color: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.text_tertiary)};

  svg {
    color: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.text_tertiary)};
  }
`

export const StyledText = styled(Text)<{ $active?: boolean }>`
  margin-top: auto;
  font-size: 10px;
  font-weight: 500;
  margin-top: 2px;
  color: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.text_tertiary)};
`
